import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, switchMap, catchError } from 'rxjs/operators';
import * as moment from 'moment';
import { LimitApplicationsService } from 'app/services/limit-applications.service';
import { of } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-limit-applications',
  templateUrl: './limit-applications.component.html',
  styleUrls: ['./limit-applications.component.css'],
})
export class LimitApplicationsComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  loanAppsLoaded: Boolean = false;
  page = 1;
  public daterange: any = {};
  public options: any = {
    locale: { format: 'YYYY-MM-DD' },
    alwaysShowCalendars: false,
  };
  showClearFilterBtn: Boolean = false;

  dateRange: any = 'Select Date';
  searchStatus: string = '';
  public errMessage: string = '';

  dateQueryParam: any = null;
  totalRec: number;

  searchForm = new FormGroup({
    nameOrId: new FormControl(''),
  });

  fileHeaders = [
    'Application ID',
    'Name of Borrower',
    'Limit Request Date',
    'Limit Request Amount',
    'Limit Application Status',
  ];

  constructor(
    private limitAppService: LimitApplicationsService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.user = this.auth.user;

    this.getLimitApplications().subscribe((data) =>
      this.gotLimitApplications(data)
    );

    this.searchForm
      .get('nameOrId')
      .valueChanges.pipe(
        debounceTime(100),
        switchMap(() => {
          this.p = 1;
          return this.getLimitApplications();
        }),
        catchError(() => of({ data: [] }))
      )
      .subscribe((data) => {
        this.gotLimitApplications(data);
      });
  }

  filterQueryParams(createFor = 'listing') {
    const params: any = {};

    if (createFor === 'listing') {
      params.page = String(this.p);
      params.limit = String(this.itemsPerPage);
    }

    const searchFor = this.searchForm.get('nameOrId').value;

    if (searchFor) params.searchFor = searchFor;

    if (this.dateQueryParam) {
      params.startDate = this.dateQueryParam.startDate;
      params.endDate = this.dateQueryParam.endDate;
    }

    if (this.searchStatus) {
      if (this.user.userType === 'bankUser') {
        params.applicationStatus = this.searchStatus;
      } else if (this.user.userType === 'bankSubUser') {
        params.makerStatus = this.searchStatus;
      }
    }

    return params;
  }

  getLimitApplications(getFor = 'listing') {
    this.loanAppsLoaded = false;
    const params = this.filterQueryParams(getFor);
    return this.limitAppService.getLimitApplications(params);
  }

  gotLimitApplications(data) {
    this.loanAppsLoaded = true;
    this.dataRec = true;
    this.dataToShow = data.data;
  }

  public chosenDate(value: any) {
    this.showClearFilterBtn = true;
    this.dateQueryParam = value;
    this.p = 1;

    this.getLimitApplications().subscribe((data) =>
      this.gotLimitApplications(data)
    );
  }

  clearFilters() {
    // Unset date query
    this.dateQueryParam = null;
    this.showClearFilterBtn = false;
    this.p = 1;
    this.searchStatus = '';

    this.getLimitApplications().subscribe((data) =>
      this.gotLimitApplications(data)
    );
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  toggleMenu() {
    $('#sidebar').toggleClass('active');
    $('#rotateN').toggleClass('rotate180');
    $('#sidebarCollapse').toggleClass('m10Sty');
    let elem = document.getElementById('asdsadada');
    if (elem.classList.contains('disnone')) {
      setTimeout(() => {
        $('#asdsadada').toggleClass('disnone');
      }, 200);
    } else {
      $('#asdsadada').toggleClass('disnone');
    }
  }

  writeToPDF(dataToWrite) {
    const doc = new jsPDF('landscape');
    const rows = this.fileWriteArray(dataToWrite).map((data) =>
      this.fileHeaders.map((h) => data[h])
    );

    doc.setFontSize(9);
    doc.autoTable(this.fileHeaders, rows);
    doc.save('Limit_Applications' + new Date().toDateString() + '.pdf');
  }

  downloadPDF() {
    this.getLimitApplications('download').subscribe((response) => {
      const data = response['data'];
      this.loanAppsLoaded = true;
      this.writeToPDF(data);
    });
  }

  getDate(d) {
    let f = new Date(d);
    let dateString = f.toString().slice(0, 15);
    return dateString;
  }

  print(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    location.reload();
  }

  fileWriteArray(dataToWrite) {
    return dataToWrite.map((data) => ({
      'Application ID': data._id,
      'Name of Borrower': data.applicantName,
      'Limit Request Date': moment(data.timestamp).format('MMM D, YYYY'),
      'Limit Request Amount': data.requestedLimit,
      'Maker Status': data.makerStatus,
      'Limit Application Status': data.applicationStatus,
    }));
  }

  writeToCSV(dataToWrite) {
    const downArr = this.fileWriteArray(dataToWrite);

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: this.fileHeaders,
      showTitle: false,
      title: 'name',
      useBom: false,
      removeNewLines: true,
      noDownload: false,
    };

    new AngularCsv(
      downArr,
      'Limit_Applications-' + new Date().toDateString(),
      options
    );
  }

  downloadCSV() {
    this.getLimitApplications('download').subscribe((response) => {
      const data = response['data'];
      this.loanAppsLoaded = true;
      this.writeToCSV(data);
    });
  }

  rowclick(value) {
    this.appObj = value;

    window.location.href = `/limitapplications/${value._id}`;
  }

  onChangeStatus(status) {
    this.searchStatus = status;
    this.showClearFilterBtn = true;
    this.getLimitApplications().subscribe((data) =>
      this.gotLimitApplications(data)
    );
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

  getNewPages(page) {
    this.p = page;
    this.getLimitApplications().subscribe((data) =>
      this.gotLimitApplications(data)
    );
  }
}
